// ورود — what the sign-in screen says this app is, in three lines.
//
// The list is here rather than in either surface file because both render it and
// two copies drift. It is also, deliberately, the whole product (core.md §7.1):
// «بیمار تمرینی بسازید» · «ویزیت را مستند کنید» · «با دستیار آموزشی گفتگو کنید».
// A fourth entry would be a promise about a screen that does not exist (core.md
// §18 lists what this app is not), and the sign-in screen is the one place a
// promise like that is never checked against reality.
//
// `titleKey`/`bodyKey` rather than text: this module is module-level and cannot
// call a hook. tests/screens.test.jsx pins that every key here resolves in BOTH
// catalogues — the first draft named `login.feature.history.*`, which no
// catalogue carried, and the screen rendered the raw dotted keys.

import { NotebookPen, Stethoscope, MessagesSquare } from 'lucide-react';

export const LOGIN_FEATURES = [
  {
    id: 'case',
    titleKey: 'login.feature.case.title',
    bodyKey: 'login.feature.case.body',
    Icon: NotebookPen,
  },
  {
    id: 'visit',
    titleKey: 'login.feature.visit.title',
    bodyKey: 'login.feature.visit.body',
    Icon: Stethoscope,
  },
  {
    id: 'chat',
    titleKey: 'login.feature.chat.title',
    bodyKey: 'login.feature.chat.body',
    Icon: MessagesSquare,
  },
];

export default LOGIN_FEATURES;
